import {Component, inject, input} from '@angular/core';
import {GameStore} from '../../store/game.store';
import { ButtonModule } from 'primeng/button';

import {ResourcesService} from '../../services/resources.service';

@Component({
    selector: 'gis-answer',
    imports: [
    ButtonModule
],
    templateUrl: './answer.component.html',
    styleUrls: ['./answer.component.scss']
})
export class AnswerComponent {
  protected store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly insidePanel = input(false);

  toggleAnswerOnMap() {
    this.store.toggleShowAnswerOnMap();
  }
}
